import { discoveryTax } from './discovery-tax';

export const caseStudies = [discoveryTax];

export const getCaseStudyBySlug = (slug: string) =>
  caseStudies.find((c) => c.slug === slug);
